'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ComponentWithBodyClass = require('../utils/ComponentWithBodyClass');

var _ComponentWithBodyClass2 = _interopRequireDefault(_ComponentWithBodyClass);

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _UsageTrackerContext = require('../context/UsageTrackerContext');

var UsageTrackerContext = _interopRequireWildcard(_UsageTrackerContext);

var _version = require('../version');

var _version2 = _interopRequireDefault(_version);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIApplication = function (_React$Component) {
  _inherits(UIApplication, _React$Component);

  function UIApplication(props) {
    _classCallCheck(this, UIApplication);

    var _this = _possibleConstructorReturn(this, (UIApplication.__proto__ || Object.getPrototypeOf(UIApplication)).call(this, props));

    (0, _setupStyledComponents.setupStyledComponents)();
    return _this;
  }

  _createClass(UIApplication, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bodyClassName = _props.bodyClassName,
          className = _props.className,
          name = _props.name,
          usageTracker = _props.usageTracker,
          TagName = _props.tagName,
          _bodyElement = _props._bodyElement,
          rest = _objectWithoutProperties(_props, ['bodyClassName', 'className', 'name', 'usageTracker', 'tagName', '_bodyElement']);

      var classes = (0, _classNames2.default)('ui-app', 'ui-app-v' + _version2.default, bodyClassName);

      return _react2.default.createElement(
        _ComponentWithBodyClass2.default,
        {
          bodyClassName: classes,
          bodyElement: _bodyElement
        },
        _react2.default.createElement(
          UsageTrackerContext.Provider,
          { value: usageTracker },
          _react2.default.createElement(TagName, _extends({
            className: (0, _classNames2.default)('private-application', className),
            'data-application-name': name
          }, rest))
        )
      );
    }
  }]);

  return UIApplication;
}(_react2.default.Component);

UIApplication.propTypes = {
  _bodyElement: _react.PropTypes.object,
  bodyClassName: _react.PropTypes.string,
  name: _react.PropTypes.string.isRequired,
  tagName: _react.PropTypes.string,
  usageTracker: UsageTrackerContext.propType
};

UIApplication.defaultProps = {
  tagName: 'div'
};

UIApplication.displayName = 'UIApplication';

exports.default = UIApplication;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/app/UIApplication.js
// module id = 623
// module chunks = 3 4